// Memória curada, perfil do profissional, memória de cliente e do escritório
// (spec-002-memoria-curada-e-perfil-do-profissional, [T016]).
//
// Vive em arquivo PRÓPRIO — não dentro de `Text.js` — porque `Text.js` já
// estava em 482 linhas antes desta tela (CLAUDE.md do monorepo: arquivos
// ≤500 linhas, quebrar por responsabilidade ao crescer). `Text.js` reexporta
// `MEMORIA_TEXT` para quem importa de `constants/Text` continuar funcionando
// (mesmo padrão de `ui-registry/contratos/tools-publicas.json` sendo um
// arquivo à parte consumido de dentro de `Text.js`).
//
// Textos literais vieram do contrato (`contracts/ui-components.md` §8) e dos
// wireframes (`design/wireframes.md`, `design/journey.md`) da spec — não
// invente copy nova sem conferir os dois.
export const MEMORIA_TEXT = {
  pageTitle: 'Memória da IA',
  pageDescription:
    'O que a IA sabe sobre você, sobre seus clientes e sobre o escritório: veja, corrija, desfaça, apague',
  noData:
    'A IA ainda não sabe nada sobre você. Peça no chat: "lembre que eu prefiro respostas curtas".',
  perfilTitle: 'Seu perfil',
  blocosTitle: 'O que a IA sabe sobre você',
  clientesTitle: 'Sobre os clientes',
  escritorioTitle: 'Sobre o escritório',
  escritorioAjuda:
    'Combinados do escritório são lidos por todos os agentes de todos os profissionais. Regra oficial (calendário fiscal, política) é Conhecimento, não memória.',
  escritorioVazio: 'A IA ainda não tem combinados do escritório.',
  escritorioNovo: 'Adicionar combinado',
  escritorioPurgeButton: 'Apagar tudo do escritório',
  escritorioPurgeText:
    'Isso apaga permanentemente tudo o que a IA sabe sobre o escritório, para todos os profissionais. Continuar?',
  auditoriaTitle: 'Histórico de alterações',
  // Subtítulo do BaseTable (DS: toda listagem leva título + subtítulo).
  auditoriaSubtitle:
    'Tudo o que foi adicionado, editado, apagado ou desfeito, com quem fez e quando.',
  auditoriaVazia: '(nenhuma alteração ainda)',
  verMaisButton: 'Ver mais',
  desfazerButton: 'Desfazer',
  desfazerText:
    'Desfazer esta alteração? A IA volta ao estado anterior a partir da próxima resposta.',
  desfeita: 'desfeita',
  aprendidoPelaIa: 'aprendido pela IA',
  exportButton: 'Exportar',
  purgeButton: 'Apagar tudo',
  // [spec-003 T016] — o purge do titular passou a apagar TAMBÉM todas as
  // conversas dele (US-7), não só perfil e memórias. Antes o texto dizia o
  // oposto: que o histórico só saía pela exclusão manual de conversas.
  purgeText:
    'Isso apaga permanentemente tudo o que a IA sabe sobre você (perfil e memórias) e todas as suas conversas com a IA. O que você gravou sobre clientes e sobre o escritório continua com eles. Não há como desfazer.',
  purgeConfirm: 'Apagar tudo',
  avisoSnapshot:
    'A IA relê estes blocos a cada mensagem: a mudança vale a partir da próxima resposta, inclusive em conversas já abertas.',
  clienteNaoSelecionado: 'Nenhum cliente selecionado.',
  clienteVazio: 'A IA não sabe nada sobre este cliente ainda.',
  // [T018] — citado em contracts/ui-components.md §2 ("memoria-do-cliente
  // injeta 'Apagar tudo sobre este cliente'"), simétrico a `purgeButton` e
  // `escritorioPurgeButton` acima.
  purgeClienteButton: 'Apagar tudo sobre este cliente',
  purgeClienteText:
    'Isso apaga permanentemente tudo o que a IA sabe sobre este cliente, para todos os profissionais. Use para atender pedido do próprio cliente.',
  apagarEntrada: 'Apagar esta entrada?',
  apagarEntradaText: 'A IA deixa de saber isso a partir da próxima resposta.',
}
